import { createApi } from "@reduxjs/toolkit/query/react";
import { Agent, AgentInfo } from "../../schema/types/agent/entity";
import { customBaseQuery } from "./common";

export const agentApi = createApi({
  reducerPath: "agentApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Agent", "AgentInfo"],
  endpoints: (builder) => ({
    getAgent: builder.query<Agent, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Agent", id: link }],
    }),
    getAgentInfo: builder.query<AgentInfo[], string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: `${link}/-info` });
          return { data: Array.isArray(data) ? data : [data] };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "AgentInfo", id: link }],
    }),
  }),
});

export const { useGetAgentQuery, useGetAgentInfoQuery } = agentApi;
